export default function HeroNav() {
  const navItems = ["Catalogs", "Editions", "Hub", "Info"];

  return (
    <nav className="absolute top-0 left-0 right-0 z-30 px-6 md:px-10 py-5 flex items-center justify-between">
      {/* Logo */}
      <a href="#" className="flex items-center gap-2 cursor-pointer group">
        <span className="text-white font-serif text-xl tracking-tight">Foliom</span>
      </a>

      {/* Center nav */}
      <ul className="hidden md:flex items-center gap-8 absolute left-1/2 -translate-x-1/2">
        {navItems.map((item) => (
          <li key={item}>
            <a
              href="#"
              className="text-white/85 hover:text-white text-sm font-medium tracking-wide transition-colors cursor-pointer whitespace-nowrap"
            >
              {item}
            </a>
          </li>
        ))}
      </ul>

      {/* Right actions */}
      <div className="flex items-center gap-5">
        <a
          href="#"
          className="hidden sm:inline text-white/85 hover:text-white text-sm font-medium cursor-pointer whitespace-nowrap"
        >
          Join us
        </a>
        <button
          type="button"
          className="bg-white text-black text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap"
        >
          Build Your List
        </button>
      </div>
    </nav>
  );
}